import { Inline, Text } from '@etg/wings';
import { CheckCircle, XCircle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { price as priceUtil } from '@eti/utils';

const inlineStyles = (isIncluded?: boolean) => css`
  ${!isIncluded && `color: #737373`};
`;

const featureTextStyles = (isStriked = false) => css`
  ${isStriked && `text-decoration: line-through`};
  width: -webkit-fill-available; /* stylelint-disable */
`;

const checkCircleStyles = css`
  color: #29a331;
`;

interface FeatureProps {
  isIncluded?: boolean;
  isStriked?: boolean;
  isPreSelectedProduct?: boolean;
  label: string;
  price?: number;
}
const Feature = ({
  isIncluded,
  label,
  isStriked = false,
  isPreSelectedProduct = false,
  price,
}: FeatureProps) => {
  const { t } = useTranslation();

  let screenReaderText = '';
  if (isIncluded) {
    screenReaderText = `${t('PaymentPage.BrandedFare.Included.Title')} - ${label}`;
  } else if (isPreSelectedProduct) {
    screenReaderText = `${t('ScreenReader.Removed.AriaLabel.Text')} - ${label}`;
  } else {
    screenReaderText = `${t('PaymentPage.BrandedFare.NotIncluded.Title')} - ${label}`;
  }

  if (isPreSelectedProduct && price && !isStriked) {
    screenReaderText += ` ${priceUtil.replaceWithCurrencyName(priceUtil.formatPrice(price))}`;
  }

  return label ? (
    <Inline aria-label={screenReaderText} className={inlineStyles(isIncluded)} noWrap spacing={8}>
      {isIncluded ? (
        <CheckCircle
          aria-hidden="true"
          className={checkCircleStyles}
          data-testid="check-circle"
          size={20}
          weight="fill"
        />
      ) : (
        <XCircle
          aria-hidden="true"
          className={inlineStyles(isIncluded)}
          data-testid="x-circle"
          size={20}
          weight="thin"
        />
      )}
      <Text
        aria-hidden="true"
        as="p"
        className={featureTextStyles(isStriked)}
        data-testid={isStriked ? 'product-name-striked-out' : 'product-name'}
      >
        {label}
      </Text>
    </Inline>
  ) : null;
};

export default Feature;
